/* eslint-disable no-use-before-define */
import { useQuery } from '@tanstack/react-query';
import { customFetch } from '~/utils/customFetch';
import { Binary, ErrorObjectString } from '~/utils/typescriptHelpers';

type IdArray = string[];

export type StaffResponse = Prettify<{
  success: 1;
  data: StaffData;
}>;

type StaffResponseError = Prettify<
  {
    success: 0;
  } & ErrorObjectString
>;

type StaffData = Prettify<{
  permissions: StaffPermissions;
  name: string;
  phone: string | number | null;
  partners: IdArray | null;
  email: string;
  am_clients: IdArray | null;
  id: number;
}>;

export type StaffPermissions = Prettify<{
  admin: number | `${number}`;
  jobs: number | `${number}`;
  partner: number | `${number}`;
  client: number | `${number}`;
  sales: number | `${number}`;
}>;

/** staff.pl permissions may return any number between 0 and 3 - any positive number is considered enabled here. */
export function isStaffPermissionEnabled(value: number | `${number}` | undefined): boolean {
  return Number(value) > 0;
}

export const staffQueryKey = ['staff'] as const;

export async function staffQueryFn() {
  const { data } = await customFetch<Prettify<StaffResponse | StaffResponseError>>('/staff.pl');
  if (data.success === 0) {
    throw new Error(data.error);
  }
  return data.data;
}

export function useStaffQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: staffQueryKey,
    queryFn: staffQueryFn,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
}
